import { BENCHMARK, VARIATIONS } from "./Constants";

const quarterRegex = /^Q([1-4])[ -](\d{4})$/;

export function flattenRow(item) {
    const row = item.data || item;
    const {
        MDRM,
        Schedule,
        LineItemCode,
        ItemName,
        Change,
        ChangeAbs,
        ...rest
    } = row;

    const quarterKeys = Object.keys(rest).filter((key) => quarterRegex.test(key));

    const exportRow = {
        MDRM,
        Schedule,
        LineItemCode,
        ItemName,
        Change,
        ChangeAbs,
    };

    quarterKeys.forEach((q) => {
        exportRow[q] = rest[q];
    });

    return exportRow;
}

export function exportToXLS(data, reportType = VARIATIONS, filename = null, columns = null) {
    if (!data || data.length === 0) {
        alert('No data available to export');
        return;
    }

    let exportData = [];

    if (reportType === BENCHMARK) {
        exportData = data.map(flattenBenchmarkRow);
    } else {
        exportData = data.map(flattenRow);
    }

    if (exportData.length === 0) {
        alert('No data available to export');
        return;
    }

    const headers = columns || Object.keys(exportData[0]);

    let table = '<table border="1"><thead><tr>';

    headers.forEach((header) => {
        const headerName = (typeof header === 'string') ? header : header.name;
        table += `<th>${headerName}</th>`;
    });
    table += '</tr></thead><tbody>';

    exportData.forEach((row) => {
        table += '<tr>';
        headers.forEach((header) => {
            const key = (typeof header === 'string') ? header : header.rssd;
            let val = row[key];

            if (
                key === 'absoluteDifferencePercent' ||
                key === 'differencePercent'
            ) {
                if (typeof val === 'number' && !isNaN(val)) {
                    val = `${val.toFixed(2)}%`;
                } else {
                    val = '';
                }
            }

            if (val === undefined || val === null) val = '';

            const escaped = String(val)
                .replace(/&/g, '&amp;')
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;');
            table += `<td>${escaped}</td>`;
        });
        table += '</tr>';
    });
    table += '</tbody></table>';

    const uri = 'data:application/vnd.ms-excel;base64,';
    const base64 = (s) => window.btoa(unescape(encodeURIComponent(s)));

    const href = uri + base64(table);

    const link = document.createElement('a');
    link.href = href;
    const safeFileName = filename
        ? filename
        : `TableData_${reportType}_${new Date().toISOString().slice(0, 10)}`;
    link.setAttribute('download', `${safeFileName}.xls`);

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}

export function flattenBenchmarkRow(row) {
    const baseRow = {
        mdrm: row.mdrm,
        schedule: row.schedule,
        lineItemCode: row.line_item_code || '-',
        itemName: row.item_name,
        absoluteDifferencePercent: row.absolute_difference_percent,
        differencePercent: row.difference_percent,
    };

    if (row.institution_a?.rssid) {
        baseRow[row.institution_a.rssid] = row.institution_a.value;
    }

    (row.compare_with || []).forEach((c) => {
        if (c?.rssid) baseRow[c.rssid] = c.value;
    });

    return baseRow;
}